import React, { useEffect,useState, useContext } from 'react';
import { LanguageContext } from './LanguageContext';
import './Maestro.css';

const Maestro = () => {
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const [isBarcodeVisible, setIsBarcodeVisible] = useState(false);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    const adjustPadding = () => {
      const header = document.querySelector('.App-header');
      const productSection = document.querySelector('.product-section');
      if (header && productSection) {
        const headerHeight = header.offsetHeight;
        console.log('Header Height:', headerHeight);  // Log header height for debugging
        productSection.style.paddingTop = `${headerHeight}px`; // Correct syntax
      }
    };
  
    adjustPadding();
    window.addEventListener('resize', adjustPadding);
  
    return () => {
      window.removeEventListener('resize', adjustPadding);
    };
  }, []);
  
  return (
    <>
    <section className="product-section">
      {/* Left container for the image */}
      <div className="product-container-left">
        <div className="product-image">
          <img src="/images/clipart1.png" alt="Maestro Product" />
        </div>
      </div>

      {/* Right container for the text/details */}
      <div className="product-container-right">
        <div className="product-details">
          <h1 className="product-title">{language === 'en' ? 'Maestro' : 'Maestro'}</h1>
          <p className="product-description">
            {language === 'en'
              ? 'Maintenance, Repair, Material and Fixture Management. Tacosoft is excited to introduce Maestro (Computerized Maintenance Management System) designed to optimize your maintenance operations and enhance overall efficiency.'
              : 'Bakım, Onarım, Malzeme ve Ekipman Yönetimi. Tacosoft, bakım operasyonlarınızı optimize etmek ve genel verimliliği artırmak için tasarlanmış Maestro (Bilgisayarlı Bakım Yönetim Sistemi) ile karşınızda.'}
          </p>
          <div className="product-actions">
            <button className="btn btn-success">{language === 'en' ? 'Buy Now' : 'Şimdi Satın Al'}</button>
            <button className="btn btn-outline-secondary">{language === 'en' ? 'Add to Cart' : 'Sepete Ekle'}</button>
          </div>
        </div>
      </div>
    </section>
    <section className="maestro-details-section">
        <div className="map-constructing">
          <div className="map-image">
            <img src="/images/avmHarita.png" alt="Maestro Product" />
          </div>
          <div className="map-explanation">
            <h1 className="map-title">{language === 'en' ? 'Smart Maps' : 'Akıllı Haritalar'}</h1>
            <p className="map-description">
              {language === 'en'
                ? 'Maestro\'s Smart Maps feature gives you a bird\'s-eye view of your building, allowing you to visualize and manage all work requests directly on the map. Easily see where maintenance tasks are needed, and create new work requests by simply clicking on the location and selecting the corresponding equipment. Simplify navigation and enhance operational control with intuitive, map-based maintenance management.'
                : 'Maestro\'nun Akıllı Haritalar özelliği, binanızın kuşbakışı görünümünü sunarak tüm iş taleplerini doğrudan harita üzerinde görselleştirmenizi ve yönetmenizi sağlar. Bakım görevlerinin nerede gerektiğini kolayca görün ve konuma tıklayarak ve ilgili ekipmanı seçerek yeni iş talepleri oluşturun. Harita tabanlı bakım yönetimi ile gezinmeyi basitleştirin ve operasyonel kontrolü artırın.'}
            </p>
            <button
              className="btn btn-outline-dark" variant="outline-dark"
              onClick={() => setIsVideoVisible(!isVideoVisible)}
            >
              {isVideoVisible ? (language === 'en' ? 'Hide Video' : 'Videoyu Gizle') : (language === 'en' ? 'Watch How It Works!' : 'Nasıl Çalıştığını İzleyin!')}
            </button>
            
            {isVideoVisible && (
            <div className="map-video">
              <video controls autoPlay>
                <source src={language === 'en' ? "/videos/planviewCompressed.mp4" : "/videos/akilliHarita2.mp4"} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            )}
          </div> 
        </div>
        <div className="barcoding">
          <div className="barcoding-explanation">
            <h1 className="barcoding-title">{language === 'en' ? 'Equipment Barcoding' : 'Ekipman Barkodlama'}</h1>
            <p className="barcoding-description">
              {language === 'en'
                ? 'With Maestro\'s Equipment Barcoding feature, each piece of equipment is uniquely identified for seamless tracking. Simply scan the barcode to instantly access equipment details, maintenance history, or even create a work request on the spot.'
                : 'Maestro\'nun Ekipman Barkodlama özelliği ile her bir ekipman benzersiz bir şekilde tanımlanır ve sorunsuz bir şekilde izlenir. Barkodu tarayarak ekipman detaylarına, bakım geçmişine anında erişin veya yerinde bir iş talebi oluşturun.'}
            </p>
            <button className="btn btn-outline-dark" onClick={() => setIsBarcodeVisible(!isBarcodeVisible)}>
              {isBarcodeVisible ? (language === 'en' ? 'Hide Video' : 'Videoyu Gizle') : (language === 'en' ? 'Watch How It Works!' : 'Nasıl Çalıştığını İzleyin!')}
            </button>
            {isBarcodeVisible && (
            <div className="barcode-video">
              <video controls autoPlay>
                <source src={language === 'en' ? "/videos/BarcodingFullEn.mp4" : "/videos/BarkodFull4Compressed.mp4"} type="video/mp4" />
               
                Your browser does not support the video tag.
              </video>
            </div>
            )}
          </div>
          <div className="barcoding-image">
            <img src="/images/barcoding.png" alt="Maestro Product" />
          </div>
        </div>
        <div className="checklist">
        <div className="checklist-image">
            <img src="/images/checklist.png" alt="Maestro Product" />
          </div>
          <div className="checklist-explanation">
            <h1 className="checklist-title">{language === 'en' ? 'Checklists' : 'Kontrol Listeleri'}</h1>
            <p className="checklist-description">
              {language === 'en'
                ? 'Manage hundreds of routine inspections effortlessly with Maestro\'s Checklists feature. Group multiple controls by type or location into a single checklist for more efficient execution. Whether it\'s safety inspections, equipment checks, or maintenance tasks, Maestro helps you stay organized and ensures nothing is overlooked, enhancing both productivity and compliance.'
                : 'Maestro\'nun Kontrol Listeleri özelliği ile yüzlerce rutin denetimi zahmetsizce yönetin. Birden fazla kontrolü tür veya konuma göre tek bir kontrol listesinde gruplayarak daha verimli bir şekilde gerçekleştirin. İster güvenlik denetimleri, ister ekipman kontrolleri veya bakım görevleri olsun, Maestro düzenli kalmanıza yardımcı olur ve hiçbir şeyin gözden kaçmamasını sağlar, hem verimliliği hem de uyumu artırır.'}
            </p>
          </div>
        </div>
        <div className="calibration">
          <div className="calibration-explanation">
            <h1 className="calibration-title">{language === 'en' ? 'Calibration' : 'Kalibrasyon'}</h1>
            <p className="calibration-description">
              {language === 'en'
                ? 'By including the ability to manage various types of calibration, Maestro not only ensures the accuracy and reliability of your equipment but also supports regulatory compliance, making it an essential tool for industries that demand precision.'
                : 'Çeşitli kalibrasyon türlerini yönetme yeteneğini içeren Maestro, yalnızca ekipmanınızın doğruluğunu ve güvenilirliğini sağlamakla kalmaz, aynı zamanda yasal uyumu da destekler ve bu da onu hassasiyet gerektiren endüstriler için vazgeçilmez bir araç haline getirir.'}
            </p>
          </div>
          <div className="calibration-image">
            <img src="/images/calibration.png" alt="Maestro Product" />
          </div>
        </div>
        <div className="stock-tracking">
          <div className="stock-tracking-image">
            <img src="/images/stock-tracking.png" alt="Maestro Product" />
          </div>
          <div className="stock-tracking-explanation">
            <h1 className="stock-tracking-title">{language === 'en' ? 'Stock Tracking' : 'Stok Takibi'}</h1>
            <p className="stock-tracking-description">
              {language === 'en'
                ? 'Track your inventory with precision using Maestro\'s stock tracking feature. Stay ahead with real-time visibility of your spare parts, tools, and supplies, ensuring you never run out of critical items. Effortlessly manage stock levels, automate reordering, and reduce downtime—boosting operational efficiency and keeping your maintenance operations running smoothly.'
                : 'Maestro\'nun stok takip özelliği ile envanterinizi hassas bir şekilde takip edin. Yedek parçalarınızın, aletlerinizin ve malzemelerinizin gerçek zamanlı görünürlüğü ile her zaman bir adım önde olun ve kritik öğelerin asla tükenmemesini sağlayın. Stok seviyelerini zahmetsizce yönetin, yeniden siparişleri otomatikleştirin ve kesinti sürelerini azaltın—operasyonel verimliliği artırın ve bakım operasyonlarınızın sorunsuz bir şekilde devam etmesini sağlayın.'}
            </p>
          </div>
        </div>
        <div className="mobileUI">
          <div className="mobileUI-explanation">
            <h1 className="mobileUI-title">{language === 'en' ? 'Mobile Optimized Interface' : 'Mobil Optimizasyonlu Arayüz'}</h1>
            <p className="mobileUI-description">
              {language === 'en'
                ? 'With a specialized and simplified GUI for smartphones and tablets, Maestro turns your devices into powerful mobile handheld terminals. Technicians can seamlessly access Maestro on the move, scan barcodes to instantly identify equipment, create and manage work requests, and even upload photos directly to the system.'
                : 'Akıllı telefonlar ve tabletler için özel ve basitleştirilmiş bir GUI ile Maestro, cihazlarınızı güçlü mobil el terminallerine dönüştürür. Teknisyenler, hareket halindeyken Maestro\'ya sorunsuz bir şekilde erişebilir, ekipmanı anında tanımlamak için barkodları tarayabilir, iş talepleri oluşturabilir ve yönetebilir ve hatta fotoğrafları doğrudan sisteme yükleyebilir.'}
            </p>
          </div>
          <div className="mobileUI-image">
            <img src="/images/companymobil.svg" alt="Maestro Product" />
          </div>
        </div>
      </section>
      </>
    
  );
};

export default Maestro;